import { render, staticRenderFns } from "./CompanyPreference.vue?vue&type=template&id=498ece14&"
import script from "./CompanyPreference.vue?vue&type=script&lang=js&"
export * from "./CompanyPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports